import { createSelector } from 'reselect';
import userSelector from './user';

const DEFAULT = '';

export default createSelector(userSelector, user => user.lanId || DEFAULT);
